import { CheckOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';
import { LayerInfo } from '../../map_types';
import styles from './layer_card.less';

export const CustomLayersButton = ({
  isSelected,
  onSelect,
  isDisabled,
  layer,
}: {
  isSelected: boolean;
  isDisabled: boolean;
  layer: LayerInfo;
  onSelect: () => void;
}) => {
  return (
    <span className={styles.radioButtonContainer}>
      <span className={styles.radioButton} onClick={onSelect}>
        <span
          className={classNames(styles.checkMark, {
            [styles.checkMark__active]: isSelected,
          })}
        >
          <CheckOutlined />
        </span>
      </span>
      <input
        className={styles.radio}
        type="radio"
        defaultChecked={isSelected}
        onClick={(e) => {
          e.stopPropagation();
          onSelect();
        }}
        disabled={isDisabled}
        aria-describedby={`${layer.name}InputDescription`}
        id={layer.name}
        name={layer.name}
        hidden
      />
    </span>
  );
};
